import React, {useCallback, useEffect, useMemo} from 'react';

import {List} from 'immutable';

import Skill from 'records/Skill';

import MultiSelect from '@components/multi-select';
import {MultiSelectProps} from '@components/multi-select/multi-select';
import SkillActions from 'actions/SkillActions';

const getValue = (skill: Skill) => skill.id;
const getLabel = (skill: Skill) => skill.skill;

interface Props extends Omit<MultiSelectProps, 'value'> {
  areSkillsFetching: boolean;
  fetchAllSkills: typeof SkillActions.fetchAllUsed;
  onChange: (newValue: List<string>) => void;
  skills: List<Skill>;
  value: List<string>;
}

export const SkillIdsField: React.FC<Props> = ({
  areSkillsFetching,
  fetchAllSkills,
  onChange,
  skills,
  value,
  ...props
}) => {
  useEffect(() => {
    fetchAllSkills().then().catch(console.error);
  }, [fetchAllSkills]);

  const jsValue = useMemo(() => (value?.toJS ? value.toJS() : []), [value]);

  const handleChange = useCallback(
    values => {
      onChange(List(values));
    },
    [onChange]
  );

  const options = useMemo(() => skills?.toJS() || [], [skills]);

  return (
    <MultiSelect
      {...props}
      placeholder="Select skills to associate with this KPI..."
      loading={areSkillsFetching}
      fullWidth
      getValue={getValue}
      getLabel={getLabel}
      options={options}
      onChange={handleChange}
      value={jsValue}
    />
  );
};
